import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { hooks as coreHooks, selectors as coreSelectors } from 'mage-core'
import { hooks as i18nHooks } from 'mage-i18n'
import { SelectField } from './../FormikBubbleField'
import { mapMidsToOptions } from '../../StoreSelector'

export default function StoreSelector() {
  const tokenHelper = coreHooks.useTokenHelper()
  const t = i18nHooks.useTranslator()
  const mids = tokenHelper.getMids()
  const [options, setOptions] = useState([])
  const client = useSelector(state => coreSelectors.clientFactory(state)('/api/users'))

  useEffect(() => {
    const updateOptions = async () => {
      const updatedOptions = await mapMidsToOptions(client, mids)
      setOptions(
        updatedOptions.map(option =>
          option.value !== option.label
            ? { ...option, label: `${option.label} (${option.value})`, key: option.value }
            : { ...option, key: option.value }
        )
      )
    }
    updateOptions()
  }, mids)

  return (
    <SelectField
      data-testid="store-selector"
      name="mid"
      label={t('hqm.support-page.create-ticket.fields.mid.label')}
      options={options}
    />
  )
}
